import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ifBrowser, isBrowser } from "../../index";
const ClientOnlyPortal = ({ children, className = "root-portal", element = "div" }) => {
    const [container, setContainer] = useState();
    useEffect(() => {
        ifBrowser(() => {
            const containerElement = window.document.createElement(element);
            containerElement.classList.add(className);
            window.document.body.appendChild(containerElement);
            setContainer(containerElement);
        });
        return () => {
            ifBrowser(() => {
                if (container) {
                    window.document.body.removeChild(container);
                }
            });
        };
    }, []);
    if (isBrowser() && container) {
        return createPortal(children, container);
    }
    else {
        return _jsx("div", { children: children });
    }
};
export default ClientOnlyPortal;
//# sourceMappingURL=ClientOnlyPortal.js.map